import React from 'react';
import PropTypes from 'prop-types';
import { graphql, gql, compose } from 'react-apollo';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ImageBanner.css';

// Component
import ImageBannerForm from '../../../components/siteadmin/ImageBannerForm';
import Loader from '../../../components/Loader';

class ImageBanner extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getImageBanner: PropTypes.object,
    })
  };

  static defaultProps = {
    data: {
      loading: true,
      image: null
    }
  };


  render() {
    const { data: { loading, getImageBanner }, title } = this.props;
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <ImageBannerForm initialValues={getImageBanner} image={getImageBanner?.image} title={title} />
    }
  }

}

export default compose(
  withStyles(s),
  graphql(gql`
        {
            getImageBanner {
                id
                title
                title_en
                title_fr
                title_it
                title_pt
                description
                description_en
                description_fr
                description_it
                description_pt
                buttonLabel
                buttonLabel_en
                buttonLabel_fr
                buttonLabel_it
                buttonLabel_pt
                image
                buttonLabel2
                buttonLabel2_en
                buttonLabel2_fr
                buttonLabel2_it
                buttonLabel2_pt
                buttonLink1
                buttonLink2
            }
        }
      `, {
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(ImageBanner);
